module.exports = __webpack_public_path__ + "static/media/itinerary.c0a701fe.jpg";